import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import submitContactForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ContactActionTile from "@ucs/Components/ContactActionTile";
import mySubmitContactForm from "@ucs/Handlers/UcsSubmitContactForm";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    submitButtonText = "submitButtonText",
    successMessage = "successMessage",
    locationsLink = "locationsLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.submitButtonText]: string;
        [fields.successMessage]: string;
        [fields.locationsLink]: LinkFieldValue;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    consentState: state.components.contactUsForm.fieldValues["consent"],
});

const mapDispatchToProps = {
    mySubmitContactForm,
    submitContactForm,
    clearForm,
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ContactFormStyles {
    contentWrapper?: InjectableCss;
    actionTile?: GridItemProps;
    socialLinksWrapper?: InjectableCss;
    contactFormArea?: GridItemProps;
    formWrapper?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    gridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    submitButtonGrid: GridItemProps;
}

export const contactFormStyles: ContactFormStyles = {
    contentWrapper: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 32px 0px;
                    `,
                    css`
                        padding-top: 55px;
                        padding-bottom: 50px;
                    `,
                    css`
                        padding-top: 65px;
                        padding-bottom: 60px;
                    `,
                    css`
                        padding-top: 80px;
                        padding-bottom: 70px;
                    `,
                    css`
                        margin-top: 96px;
                        padding-bottom: 88px;
                    `,
                ]);
            }}
        `,
    },
    actionTile: {
        width: [12, 6, 6, 3, 3],
        css: css`
            line-height: 24px;

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 5px 36px;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    socialLinksWrapper: {
        css: css`
            width: 100%;
            margin-top: 80px;
            margin-bottom: 90px;

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin-top: 45px;
                        margin-bottom: 30px;
                    `,
                    css`
                        margin-top: 55px;
                        margin-bottom: 40px;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    contactFormArea: {
        width: [12, 12, 6, 6, 6],
        // css: css`
        //     input,
        //     textarea,
        //     select {
        //         border: 2px solid #999999 !important;
        //     }
        // `,
    },
    formWrapper: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-left: 36px;
                        padding-right: 36px;
                    `,
                    css`
                        // padding-left: 20px;
                        // padding-right: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    submitButton: {
        css: css`
            width: 100%;
            margin: 24px 0;

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-left: 36px;
                        padding-right: 36px;
                    `,
                    css`
                        padding-left: 36px;
                        padding-right: 36px;
                    `,
                    css``,
                    css``,
                    css`
                        padding-left: 36px;
                        padding-right: 36px;
                    `,
                ]);
            }}
        `,
    },
    successModal: { sizeVariant: "small" },
    messageTextGridItem: { width: 12 },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0px 10px;
        `,
    },
    submitButtonGrid: {
        width: 12,
        css: css`
            // padding: 0px 10px;
            padding-left: 0px;
            padding-right: 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        // padding-left: 20px;
                        // padding-right: 10px;
                        padding-left: 36px;
                        padding-right: 36px;
                    `,
                    css`
                        // padding-left: 20px;
                        // padding-right: 10px;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
};

const styles = contactFormStyles;
const emailsRegexp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

export const ContactFormContext = React.createContext<ContextType>({
    validators: {},
});

const ContactUsWrapper = styled.div`
    width: 100%;
    background: #e5e5e5;
`;

interface DefaultLocationDetails {
    email: string,
    hours: string,
    phone: string
}

const ContactForm = ({
    id,
    fields,
    consentState,
    submitContactForm,
    mySubmitContactForm,
    clearForm,
    setFieldValue,
    siteName
}: Props) => {
    const [defaultLocation, setDefaultLocation] = useState<DefaultLocationDetails>();
    const upperCanadaLocationDetails: DefaultLocationDetails = { email: "sales_toronto@ucfp.com", hours: "Weekdays 8:00am - 5:00pm EST", phone: "1 866 265 0624" };
    const sierraLocationDetails: DefaultLocationDetails = { email: "sales_chicago@sierrafp.com", hours: "Weekdays 7:00am - 5:00pm CST", phone: "1 800 646 7564" };

    useEffect(() => {
        if (siteName) {
            if (siteName.toLowerCase() === "upper canada") {
                setDefaultLocation(upperCanadaLocationDetails)
            }
            else if (siteName.toLowerCase() === "sierra") {
                setDefaultLocation(sierraLocationDetails)
            }
        }
    }, [siteName])

    const { submitButtonText, successMessage } = fields;
    const [validators] = useState<{ [key: string]: Validator | undefined }>({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toasterContext = React.useContext(ToasterContext);
    const locationsLink = useGetLink(fields.locationsLink || "");
    toasterContext.defaultTimeout = 5000;

    const salesEmail = getCookie("SalesEmailCookie") || "";
    const phoneNumber = getCookie("LocationPhoneNumber1") || "";
    const openingHours = getCookie("LocationOpeningHours") || "";

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const widgetValidators: Validator[] = [];
        Object.keys(validators).forEach(key => {
            const validator = validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });
        const results = widgetValidators.map(v => v());        
        if (results.every(o => o)) {
            const emailRecipients = salesEmail || defaultLocation?.email || "info@ucfp.com";
            setIsSubmitting(true);
            mySubmitContactForm({
                emailRecipients,
                onSuccess: () => {
                    setIsModalOpen(true);
                    setIsSubmitting(false);
                },
                onComplete() {
                    // "this" is targeting the object being created, not the parent SFC
                    this.onSuccess?.();
                },
            });
        } else {
            const y = document!.getElementById("contactForm")!.getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({ top: y, behavior: "smooth" });
            toasterContext.addToast({
                body: siteMessage("Contact_FormFailure"),
                messageType: "danger",
            });
        }
    };

    const modalCloseHandler = () => {
        setIsModalOpen(false);
        clearForm();
    };

    const continueButtonClickHandler = () => {
        setIsModalOpen(false);
        clearForm();
    };

    const onConsentChange = (event: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setFieldValue({ key: "consent", value: `${value}` });
    };

    // const FormWrapper = styled.div`
    //     flex: 1;
    //     flex-direction: column;
    //     display: flex;
    //     align-items: flex-end;

    //     > form {
    //         width: 470px;
    //         padding-right: 100px;

    //         > div[class^="GridWrapper"],
    //         > div[class*=" GridWrapper"] {
    //             margin: auto;
    //         }

    //         div[class^="GridOffset"],
    //         div[class*=" GridOffset"] {
    //             margin: 0px;
    //             width: 100%;
    //         }
    //     }

    //     ${({ theme }) =>
    //         breakpointMediaQueries(theme, [
    //             css`
    //                 > form {
    //                     width: 100%;
    //                     margin-right: 0px;
    //                     padding: 30px;
    //                 }
    //             `,
    //             css`
    //                 > form {
    //                     width: 100%;
    //                     margin-right: 0px;
    //                     padding: 30px;
    //                 }
    //             `,
    //             css`
    //                 > form {
    //                     width: 100%;
    //                     margin-right: 0px;
    //                     padding: 30px;
    //                 }
    //             `,
    //             css``,
    //             css``,
    //         ])};
    // `;

    return (
        <ContactUsWrapper>
            <Zone contentId={id} zoneName="HeroImage" />

            <StyledWrapper {...styles.contentWrapper}>
                <GridContainer
                    style={{
                        margin: "auto",
                    }}
                >
                    <GridItem {...styles.actionTile}>
                        <ContactActionTile
                            icon="email"
                            title={translate("Email us")}
                            info={salesEmail || defaultLocation?.email || "info@usfp.com"}
                            ctaMessage={translate("Send an email")}
                            ctaFunc={() => window.open(`mailto:${salesEmail || defaultLocation?.email || "info@usfp.com"}`, "_self")}
                        ></ContactActionTile>
                    </GridItem>
                    <GridItem {...styles.actionTile}>
                        <ContactActionTile
                            icon="phone"
                            title={translate("Call us")}
                            info={openingHours || defaultLocation?.hours || ""}
                            ctaMessage={phoneNumber || defaultLocation?.phone || ""}
                            ctaFunc={() =>
                                window.open(
                                    `tel:${phoneNumber.replace(" ", "").replace("\n", "").replace("\t", "") || defaultLocation?.phone.replace(" ", "").replace("\n", "").replace("\t", "")}`,
                                    "_self",
                                )
                            }
                        ></ContactActionTile>
                    </GridItem>
                    <GridItem {...styles.actionTile}>
                        <ContactActionTile
                            icon="send"
                            title={translate("Message us")}
                            info={translate("Anytime you want")}
                            ctaMessage={translate("Submit a request")}
                            ctaFunc={() =>
                                document.getElementById("formSection")?.scrollIntoView({ behavior: "smooth" })
                            }
                        ></ContactActionTile>
                    </GridItem>
                    <GridItem {...styles.actionTile}>
                        <ContactActionTile
                            icon="location"
                            title={translate("Locate us")}
                            info={siteMessage("LocateUs_Text") as string}
                            ctaMessage={translate("Our offices")}
                            ctaFunc={() => {
                                window.location.href = locationsLink.url || "/our-offices";
                            }}
                        ></ContactActionTile>
                    </GridItem>
                </GridContainer>

                <StyledWrapper {...styles.socialLinksWrapper}>
                    <Zone contentId={id} zoneName="SocialLinks" />
                </StyledWrapper>

                <GridContainer
                    style={{
                        margin: "auto",
                    }}
                >
                    <GridItem {...styles.contactFormArea}>
                        <Zone contentId={id} zoneName="ContentArea" />
                    </GridItem>
                    <GridItem {...styles.contactFormArea} id="formSection">
                        <ContactFormContext.Provider value={{ validators }}>
                            <form id="contactForm" onSubmit={handleFormSubmit} noValidate data-test-selector="contact_form">
                                <GridContainer>
                                    <StyledWrapper {...styles.formWrapper}>
                                        <Zone contentId={id} zoneName="Content" />
                                    </StyledWrapper>
                                    <GridItem
                                        width={12}
                                        css={css`
                                            ${({ theme }) => {
                                                return breakpointMediaQueries(theme, [
                                                    css`
                                                        padding-left: 36px;
                                                        padding-right: 36px;
                                                    `,
                                                    css`
                                                        padding-left: 36px;
                                                        padding-right: 36px;
                                                    `,
                                                    css`
                                                        padding-right: 0px;
                                                        padding-left: 0px;
                                                    `,
                                                    css`
                                                        padding-right: 0px;
                                                        padding-left: 0px;
                                                    `,
                                                    css`
                                                        padding-right: 0px;
                                                        padding-left: 0px;
                                                    `,
                                                ]);
                                            }}
                                        `}
                                    >
                                        <Checkbox
                                            uid="consent"
                                            css={css`
                                                margin-right: 10px;
                                                margin-top: 3px;
                                            `}
                                            onChange={onConsentChange}
                                            checked={consentState === "true"}
                                        ></Checkbox>
                                        <Zone contentId={id} zoneName="Subscribe" />
                                    </GridItem>
                                    <GridItem {...styles.submitButtonGrid}>
                                        <Button {...styles.submitButton} type="submit" disabled={isSubmitting}>
                                            {submitButtonText}
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                                <Modal
                                    headline={translate("Message Sent")}
                                    contentLabel={successMessage}
                                    {...styles.successModal}
                                    isOpen={isModalOpen}
                                    handleClose={modalCloseHandler}
                                >
                                    <GridContainer {...styles.modalContainer}>
                                        <GridItem {...styles.messageTextGridItem}>
                                            <Typography {...styles.messageText}>{successMessage}</Typography>
                                        </GridItem>
                                        <GridItem {...styles.buttonGridItem}>
                                            <Button {...styles.continueButton} onClick={continueButtonClickHandler}>
                                                {translate("Close")}
                                            </Button>
                                        </GridItem>
                                    </GridContainer>
                                </Modal>
                            </form>
                        </ContactFormContext.Provider>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        </ContactUsWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ContactForm),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.submitButtonText,
                displayName: "Submit Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Send",
            },
            {
                name: fields.successMessage,
                displayName: "Submit Success Message",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Thank you for your inquiry. A customer service representative will contact you shortly.",
            },
            {
                name: fields.locationsLink,
                displayName: "Locations Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
